import { DatasetId } from '../../meta/types/wms/Dataset';
import { MosaickingOrder } from '../../meta/types/wms/Layer';

const INSTANCE_ENDPOINTS = ['ID', 'WMS', 'WMTS', 'WFS', 'WCS'];

export type DropDownType = {
  key: string;
  value: string;
  text: string;
};

export const INSTANCE_ENDPOINT_OPTIONS: DropDownType[] = INSTANCE_ENDPOINTS.map(x => ({
  key: x,
  value: x,
  text: x,
}));

export const USWEST_DATASOURCES = [DatasetId.L8L1C, DatasetId.DEM, DatasetId.MODIS];
export const CREODIAS_DATASOURCES = [DatasetId.S3OLCI, DatasetId.S3SLSTR, DatasetId.S5PL2];

export const BASE_MOSACKING_ORDERS = [
  { value: MosaickingOrder.MOST_RECENT, text: 'Most recent', key: MosaickingOrder.MOST_RECENT },
  { value: MosaickingOrder.LEAST_RECENT, text: 'Least recent', key: MosaickingOrder.LEAST_RECENT },
];

export const CC_MOSAICKING_ORDERS = [
  ...BASE_MOSACKING_ORDERS,
  { value: MosaickingOrder.LEAST_CC, text: 'Least cloud coverage', key: MosaickingOrder.LEAST_CC },
];
